
import React, { Component } from 'react'
import { 	
    postPromise,	
	createUrl,
	stat,
	getCookie,
	getLang
} from '../../common/utils'
import { 
    ColorPic,
    Countdown,
    ColorSelector,
    TipPop,
	jumpToLogin,
	DiskContainer
} from './componentsv2'
import { ONECLOUD_API_HOST } from '../../common/consts'
import t from '../../i18n/purchase'

const api = {
    checklogin: `${ONECLOUD_API_HOST}/user/checklogin`,
    getconfig: `${ONECLOUD_API_HOST}/opensale/getconfig`,  
    commit: `${ONECLOUD_API_HOST}/opensale/commit`    
}

const STATUS_NOTBEGIN = 0	// 活动未开始
const STATUS_BUYING = 1		// 抢购中
const STATUS_END = 2		// 抢购结束
let GET_CONFIG_LOOP_TIMES = 0


/* 开放售卖原价【CN、HK版】、满减活动【CN版】*/
export default class OpensalePurchaseV2 extends Component {
    constructor(props) {
		super(props)    
		this.config = {
			price: 599,
			discount: 119,
			diskPrice: 585,			
			diskCount: 50
		}    
		this.lang = getLang()
        this.state = {
            hasLogin: false,
			loginRemindShow: true, 
			hasDiscount: false,                       
			                          
			color: 'black',
			colorConfig:[ 
				{color:'black', text:t('color_black'), has:1},
				{color:'blue', text:t('color_blue'), has:1},
				{color:'orange', text:t('color_orange'), has: this.lang === 'cn' ? 1 : 0}
			],			
			popShow: false, 
			popMsg: '', 
			popJump: '', 
			popBtn: t('ok'), 	
			loadingTime: false,
			diskChecked: false, 
		}      		
    }

    componentDidMount() {
        this.setHtmlBg()
        this.getConfig()		
        this.checkLogin()       
        this.swipeColorPic()        
    }

    setHtmlBg() {        
        $('html').addClass('whitebg')        
    }

    getConfig = () => {
		if (getCookie('lang') !== 'cn') return

		let doneCb = res => {    			    
			let success = data=>{
                
                //test
                //data = {mj_status: 1, seckill_status:0,seckill_stime:'2018-05-10 10:00:00',seckill_end_time:'2018-05-10 10:44:36'}
                
                const { mj_status } = data
				this.setState({					
					hasDiscount: mj_status === 1 ? true : false			
				})			
			}
			this.responeHandler({res, success})
		}
		let failCb = res => {
			if (GET_CONFIG_LOOP_TIMES == 1) {
				this.showPopHandler(t('notifi_yongdu'))
			} else {
				GET_CONFIG_LOOP_TIMES++
				setTimeout(this.getConfig, 2000);
			}
		}
		postPromise(api.getconfig).done(doneCb).fail(failCb)
    }            
    
    checkLogin() {
        if (window.siteHasLogined) {
            this.setState({
                hasLogin: true
            })
        } else {
            let doneCb = res => {
                +res.iRet === 0 && this.setState({hasLogin: true})               
            }
            postPromise(api.checklogin).done(doneCb)
        }        
    }    

    showPopHandler = (msg, url, btn) => {
		this.setState({
			popShow: true,
			popMsg: msg,
			popJump: url || '',
			popBtn: btn || t('ok')
		})
    }
    
    commonErrorHandler(resCode, sMsg) {
		let statusList = {
			'30004' : t('rtncode_30004'),
			'30006' : t('rtncode_30006'),
			'30008' : t('rtncode_30008'),
			'30009' : t('rtncode_30009'),
			'40000' : t('rtncode_40000'),
			'30003' : t('rtncode_30003'),
			'30106' : t('rtncode_30106'),
			'-2' : t('rtncode__2'),
			'-2004': t('rtncode__2004'),
			'-2000': t('rtncode__2000'),
			'-1003': t('rtncode__1003'),
			'-5': t('rtncode__5'),

			"41006": t('rtncode_41006'),
			"41007": t('rtncode_41007_2'),
			"41009": t('rtncode_41009'),
			"41012": t('rtncode_41012'),
			"41013": t('rtncode_41013'),
			"41014": t('rtncode_41014'),
			'41016': t('rtncode_41016'),
			'41018': t('rtncode_41018'),
			"41022": t('rtncode_41022')
		}
		let sellOutList = {
			'30005' : t('rtncode_30005'),
			'30016' : t('rtncode_30016'),
			'30025' : t('rtncode_30025'),
			'30026' : t('rtncode_30026')
		}

		if(resCode == -501){
			let url = window.location.href
			jumpToLogin()
		}else if(resCode == 30007) {
			this.showPopHandler(t('rtncode_30007'), createUrl('html/usercenter'), t('check_order'))
		} else if(resCode == 30303) {
			this.showPopHandler(t('rtncode_30303'))
			this.getConfig()
		}
		else if(sellOutList[resCode]){
			if(resCode==30005){
				this.showPopHandler(sellOutList[resCode])
			}else {
				this.showPopHandler(sellOutList[resCode],'',t('tips_continue'))
				//this.getColorList()
			}
		} else if(statusList[resCode]) {
			this.showPopHandler(statusList[resCode])
		} else if (resCode !== 0) { // CN
			this.showPopHandler(sMsg)
		}
		// if (callback&&typeof callback=="function"){
		// 	callback(resCode,res)
		// }
	}

	responeHandler({res, success}){
		const resCode = res.iRet;
		this.commonErrorHandler(resCode, res.sMsg)

		if(resCode==0) {
			if(res.data){
				success(res.data);
			}else {
				success()
			}
		}
    }
    
    commonFailCb = () => {
		this.showPopHandler(t('notifi_yongdu'))
	}

    swipeColorPic() {        
        const galleryTop = new Swiper('.gallery-top', {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
        const galleryThumbs = new Swiper('.gallery-thumbs', {
            centeredSlides: true,
            slidesPerView: 5,
            touchRatio: 0.2,
            slideToClickedSlide: true,
        });
        galleryTop.controller.control = galleryThumbs;
        galleryThumbs.controller.control = galleryTop;
    }

    closeLoginRemind = () =>{
        this.setState({
            loginRemindShow: false
        })
    }

    switchColor = (color) =>{        
        this.setState({ color })
    }

    popClose = ()=> {
        this.setState({popShow: false})
	}
	
	updateDiskData = (data) => {
		this.setState(data) 
	}

    submit = (e) => {
		e.preventDefault() 	
		this.setState({loadingTime: true})
		let doneCb = res => {
			const resCode = res.iRet;
			if (resCode==0) {
				let jumpUrl = createUrl('html/order', {type:'opensale', orderid: res.data.order_id})
				window.setTimeout(()=>{
					window.location.href = jumpUrl
				},0)              
			} else {
				this.setState({loadingTime: false})
				this.commonErrorHandler(resCode, res.sMsg)				
			}
		}
		const { diskChecked } = this.state
        let postData = {
			[`${this.state.color}_num`]: 1,
			hd_num: diskChecked ? 1 : 0,
			sub_type: this.state.hasDiscount ? 1 : 0           
		}
		
		let failCb = () => {
			this.setState({loadingTime: false})
			this.commonFailCb()
		}
		postPromise(api.commit, postData).done(doneCb).fail(this.failCb)
		stat('purchase', 'opensale')
    }       

    render() {
		const { hasLogin, loginRemindShow, color, status, popShow, popBtn, popMsg, popJump, currTime, buyTime, loadingTime, hasDiscount,
			diskChecked,
		 } = this.state       

        const loginRemindDom = 
            <div className="np-buylogin">
                <div className="np-main">					
					<p>{t('login_remind')}<a href="javascript:;" onClick={jumpToLogin}>{t('login_now')}</a><i className="i-close" title={t('close')} onClick={this.closeLoginRemind}></i></p>
                </div>
            </div>
		
		const { price, discount, diskPrice, diskCount } = this.config
		const onecloudMony = hasDiscount ? price - discount : price
		const diskMoney = diskChecked ? diskPrice - diskCount : 0
		const totalPrice = onecloudMony + diskMoney
		
        return (
            <div>
                { !hasLogin && loginRemindShow && loginRemindDom }
                { popShow && <TipPop btnTxt={popBtn} msg={popMsg} jump={popJump} onClose={this.popClose}/> }
                <div className="np-main">
                    <div className="np-buy-box">
                        <ColorPic currColor={color} hasSoldout={false} />
                        <div className="np-buy-main">
						{
							hasDiscount ?
							t('mj_price_title')
							:
							<div className="np-buy-text">
                                <h2>{t('banner_title')}</h2>                               							
								{t('sub_title')}     
								{t('price_official_v2')}                                                        
                            </div>
						}                                                   
                            <ColorSelector colorConfig={this.state.colorConfig} currColor={color} onChange={this.switchColor} />  
							{/* { this.lang === 'cn' && 
								<DiskContainer								
									diskPrice={diskPrice} 
									diskCount={diskCount}
									updateDiskData={this.updateDiskData}
								/> } */}
							{/*hasDiscount && t('mj_price')*/}    
							 { this.lang === 'cn' && <TotalPrice price={totalPrice}/> } 
							<div className="np-buy-btn">                                             
								<SubmitBtnRender 									
									loadingTime={loadingTime} 
									onclick={this.submit}
									disabled={false}/>
							</div>
							{ t('goods_tip') }                            
                        </div>
                    </div>
                </div>
            </div>
        )        
    }
}    

const SubmitBtnRender = ({loadingTime, onclick, disabled}) => {
	return disabled ? 
		<a href="javascript:;" className='btn-np btn-np-disable'>{t('buy_now')}</a> :
		<a href="javascript:;" className='btn-np' onClick={onclick}>{t('buy_now')}{loadingTime?<i className="i-oc-loading"></i>:null}</a>
}

const TotalPrice = ({price}) => {
	return <div className="np-buy-sum">
				<p>合计：<em>{price}</em>元</p>
			</div>
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/OpensalePurchaseHK.jsx